module.exports = __webpack_public_path__ + "static/media/01_tn.71b68f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/01_tn.jpg
// module id = 215
// module chunks = 0